// extracted by mini-css-extract-plugin
export default {"socialShare":"ZD9tceqa","mobile":"mobile","rambler-share":"rambler-share","socialShareTitle":"sCC5XJE5","socialShareSocials":"NjEUm33W","desktop":"desktop"};